export enum TaskOwnerType {
  DRIVER = 'DRIVER',
}
